'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = ShareButtons;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _shareItem = require('./shareItem');

var _shareItem2 = _interopRequireDefault(_shareItem);

var _displayTypes = require('./displayTypes');

var _supportedCommunities = require('./supportedCommunities');

var _supportedCommunities2 = _interopRequireDefault(_supportedCommunities);

var _d3Collection = require('d3-collection');

var _taJsToolbox = require('ta-js-toolbox');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//region CSS
require('ta-semantic-ui/semantic/dist/components/icon.css');
require('ta-semantic-ui/semantic/dist/components/button.css');
require('ta-semantic-ui/semantic/dist/components/list.css');
//endregion

/**
 * Renders social sharing buttons.
 * @param {Object} props See {@link ShareButtons.propTypes}
 * @returns {XML}
 * @constructor
 */
function ShareButtons(props) {

  // Set up group class, depending on the desired display type.
  var groupClass = 'ui';

  switch (props.displayType) {
    case _displayTypes.HORIZONTAL_ICONS:
      groupClass += ' horizontal link list';
      break;

    case _displayTypes.VERTICAL_BUTTONS:
      groupClass += ' vertical labeled icon buttons';
      break;
  }

  // Add "inverted" if necessary
  if (props.inverted) {
    groupClass += ' inverted';
  }

  // Prepare Communities array
  var mappedCommunities = (0, _d3Collection.map)(props.communities, function (d) {
    return d.type;
  });

  return _react2.default.createElement(
    'div',
    { className: groupClass },
    _supportedCommunities2.default.map(function (communityType) {
      var community = mappedCommunities.get(communityType);
      if (community === undefined) {
        return;
      }

      return _react2.default.createElement(_shareItem2.default, _extends({ key: communityType,
        displayType: props.displayType,
        inverted: props.inverted,
        shareUrl: _taJsToolbox.shareActionFactory[communityType](_extends({
          hashtags: props.hashtags,
          url: props.url
        }, community)) }, community));
    })
  );
}

ShareButtons.propTypes = {
  /**
   * The display type. Currently one of either HORIZONTAL_ICONS or
   * VERTICAL_BUTTONS.
   * @see {@link HORIZONTAL_ICONS}, {@link VERTICAL_BUTTONS}
   */
  displayType: _react.PropTypes.oneOf([_displayTypes.HORIZONTAL_ICONS, _displayTypes.VERTICAL_BUTTONS]),
  /**
   * For displaying the list on a dark background.
   */
  inverted: _react.PropTypes.bool,
  /**
   * Community objects, as provided by the External Services API service by
   * Newsnet.
   * @type {Array.Object}
   */
  communities: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    type: _react.PropTypes.string.isRequired,
    url: _react.PropTypes.string,
    description: _react.PropTypes.string,
    count: _react.PropTypes.number
  })),
  /**
   * Hashtags as an array of strings. Facebook will only use the first one.
   * @type {Array.string}
   */
  hashtags: _react.PropTypes.arrayOf(_react.PropTypes.string),
  /**
   * The URL to share. Will be overriden by URLs in the {@link communities}
   * array.
   * @type {string}
   */
  url: _react.PropTypes.string
};

ShareButtons.defaultProps = {
  displayType: _displayTypes.VERTICAL_BUTTONS,
  inverted: false,
  communities: [{
    type: 'twitter',
    description: 'Bei Twitter veröffentlichen',
    count: 0
  }, {
    type: 'facebook',
    description: 'Über Facebook teilen',
    facebook_id: 147124108642216,
    count: 0
  }],
  url: window.location.href
};


//////////////////
// WEBPACK FOOTER
// ./~/ta-react-share-buttons/dist/shareButtons.js
// module id = 361
// module chunks = 0